var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_c('vs-avatar',{staticClass:"flex-shrink-0 mr-2",attrs:{"src":_vm.avatar,"text":_vm.avatarText,"size":"30px"},on:{"click":_vm.onClickNameLink}}),_c('p',{staticClass:"text-inherit link-string truncate ...",on:{"click":_vm.onClickNameLink}},[_vm._v("\n    "+_vm._s(_vm.params.value)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }